export default __webpack_public_path__ + "static/media/logowhitetext.781a7c75.svg";